// extracted by mini-css-extract-plugin
export default {"properties":"URSbV","propertiesRow":"WE9ic","propertiesColumn":"xIG19"};